var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealthCheckIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 3.86719C11.7119 3.86719 12.2891 3.29007 12.2891 2.57812H13.5781V0H8.42188V2.57812H9.71094C9.71094 3.29007 10.2881 3.86719 11 3.86719Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.91016 1.28906V22H18.0898V1.28906H14.8672V3.86719H13.2319C12.7857 4.63697 11.9523 5.15625 11 5.15625C10.0477 5.15625 9.2143 4.63697 8.76807 3.86719H7.13281V1.28906H3.91016ZM14.2227 19.3789H6.48828V18.0898H14.2227V19.3789ZM15.5117 16.8008H6.48828V15.5117H15.5117V16.8008ZM9.06641 9.06641H10.3555V7.77734H11.6445V9.06641H12.9336V10.3555H11.6445V11.6445H10.3555V10.3555H9.06641V9.06641ZM15.5117 12.9336V14.2227H6.48828V12.9336H15.5117Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthCheckIn);
export default __webpack_public_path__ + "static/media/health-check-in.9871548795d454aeecb44e313d3c84b3.svg";
export { ForwardRef as ReactComponent };